import { useValue } from "@stg-oneportal/corets-use-value"
import { useContainer } from "./useContainer"

export const useNavbarTitle = () => useValue(useContainer().navbarTitle)
